import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { CappedFlexiSection } from "../../../Common/SIPP/IncomePaymentDetails/CappedFlexiSection";
import { IncomeRequired } from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import {
    incomePaymentDetailsLabels,
    incomePaymentDetailsMessages,
} from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";

interface IOtherIncomePaymentDetailsProps extends IProcessComponentProps {
    data: DrawdownModel;
    pensionBase: PensionBase;
}

interface IOtherIncomePaymentDetailsState {}

export class OtherIncomePaymentDetails extends ProcessComponent<
    IOtherIncomePaymentDetailsProps,
    IOtherIncomePaymentDetailsState
> {
    constructor(props: any) {
        super(props);
    }

    private handleChange(changes) {
        const { onChange, data } = this.props;
        this.onDataChange(onChange, changes, data, "Income");
    }

    private getIncomeProps = (data, onChange) => {
        return {
            data: data?.Income,
            onChange: (changes) => this.onDataChange(onChange, changes, data, "Income"),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    public render(): JSX.Element {
        const { data, onChange, pensionBase } = this.props;
        const drawdownType = data?.DrawdownType;
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={incomePaymentDetailsLabels.needToProvideAnIncome}
                    selected={data?.Income?.TaxableIncomeRequiredInAddition || false}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.handleChange({
                            TaxableIncomeRequiredInAddition: v,
                            TargetSpecificArrangements: null,
                            GrossIncomePerPayment: null,
                            GrossIncomePerPaymentFromPension: null,
                            IncomePaymentAllocations: null,
                            GrossInitialIncomePayment: null,
                        });
                        onChange({
                            IncomeDisinvestmentAllocations: null,
                        });
                    }}
                />
                {data?.Income?.TaxableIncomeRequiredInAddition && (
                    <>
                        <IncomeRequired
                            {...this.getIncomeProps(data, onChange)}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            drawdownType={drawdownType}
                            hasCappedArrangement={!isNullOrEmpty(data?.ExistingArrangements?.CappedModels)}
                            pensionBase={pensionBase}
                            isITFC={false}
                        />
                        {data?.Income?.TargetSpecificArrangements && (
                            <CappedFlexiSection
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onRef={(ref) => this.appendChild(ref)}
                                income={data?.Income}
                                onIncomeChange={(changes) => this.onDataChange(onChange, changes, data, "Income")}
                                data={data?.ExistingArrangements}
                                onChange={(changes) =>
                                    this.onDataChange(onChange, changes, data, "ExistingArrangements")
                                }
                                drawdownType={drawdownType}
                                pensionProtection={pensionBase?.PensionProtection}
                            />
                        )}
                        <RegularIncomePayment
                            {...this.getIncomeProps(data, onChange)}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            drawdownType={drawdownType}
                            pensionBase={pensionBase}
                            processType={processTypeEnum.TakePensionBenefits}
                            isITFC={false}
                        />
                    </>
                )}
            </>
        );
    }
}
